const FaqAccordion = {
	init() {
		// Find all FAQ sections
		const faqSections = document.querySelectorAll('.schema-faq-section');
		
		if (faqSections.length === 0) {
			return;
		}

		// Add click event listeners to each FAQ question
		faqSections.forEach((section) => {
			const question = section.querySelector('.schema-faq-question');
			const answer = section.querySelector('.schema-faq-answer');
			
			if (question && answer) {
				// Add cursor pointer to question
				question.style.cursor = 'pointer';
				
				// Add click event listener
				question.addEventListener('click', () => {
					// Toggle active class on section
					section.classList.toggle('active');
				});
				
				// Add keyboard support for accessibility
				question.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						question.click();
					}
				});
				
				// Make question focusable for accessibility
				question.setAttribute('tabindex', '0');
				question.setAttribute('role', 'button');
				question.setAttribute('aria-expanded', 'false');
				question.setAttribute('aria-controls', answer.id || 'faq-answer');
			}
		});
		
		// Update aria-expanded attributes when sections are toggled
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const section = mutation.target;
					const question = section.querySelector('.schema-faq-question');
					const isActive = section.classList.contains('active');
					
					if (question) {
						question.setAttribute('aria-expanded', isActive.toString());
					}
				}
			});
		});
		
		faqSections.forEach((section) => {
			observer.observe(section, { attributes: true });
		});
	},
};

export default FaqAccordion; 